import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=d23a8c48&scoped=true"
import script from "./SimpleButton.vue?vue&type=script&lang=ts"
export * from "./SimpleButton.vue?vue&type=script&lang=ts"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=d23a8c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a8c48",
  null
  
)

export default component.exports